// valorantApi.ts
import {MapResponse, WeaponsResponse} from './types'; // Adjust path if needed

export class ValorantApi {
  private static BASE_URL = 'https://valorant-api.com/v1';

  /**
   * Fetch map data by UUID
   * @param mapUuid - UUID of the map
   * @returns Promise resolving to map data
   */
  static async getMap(mapUuid: string): Promise<MapResponse> {
    const url = `${this.BASE_URL}/maps/${encodeURIComponent(mapUuid)}`;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Failed to fetch map data: ${response.status} ${response.statusText}`);
    }

    const result: MapResponse = await response.json();
    return result;
  }

  static async getWeapons(): Promise<WeaponsResponse> {
    const url = `${this.BASE_URL}/weapons`;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Failed to fetch weapons: ${response.status} ${response.statusText}`);
    }

    const result: WeaponsResponse = await response.json();
    return result;
  }
}
